export function formatDate(value) {
  if (value === null) {
    return '---'
  }
  if (value.length === 10) {
    value += 'T00:00'
  }
  return new Date(value).toLocaleDateString()
}

export function formatTime(value) {
  if (value === null) {
    return '---'
  }
  return new Date(value).toLocaleTimeString()
}

export function formatDatetime(value) {
  if (value === null) {
    return '---'
  }
  return `${formatDate(value)} - ${formatTime(value)}`
}
